import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import KnowledgeBaseTab from "./KnowledgeBaseTab";
import { EntityType } from "./types";

interface BotConfigModalProps {
  open: boolean;
  onClose: () => void;
  entityName: string;
  entityId: string;
  entityType: EntityType;
  onDataAdded?: () => void;
}

const BotConfigModal: React.FC<BotConfigModalProps> = ({
  open,
  onClose,
  entityName,
  entityId,
  entityType,
  onDataAdded,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          minHeight: "70vh",
        },
      }}
    >
      <DialogTitle
        sx={{
          m: 0,
          p: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h6" component="div">
          Chatbot Configuration: <strong>{entityName}</strong>
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0 }}>
        <Box sx={{ p: 2 }}>
          <KnowledgeBaseTab
            entityId={entityId}
            entityType={entityType}
            vectorNamespace={`${entityType}_${entityId}`}
            onDataAdded={onDataAdded}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default BotConfigModal;
